import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'
import { HttpService } from '@ui-components/services';
import { IResponse } from '@interfaces/index';
import { IProduct } from 'projects/ui-components/src/interfaces/IProduct';

@Injectable({
  providedIn: 'root',
})
export class ProductService {

  constructor(
    private _http_service: HttpService
  ) { }

  getSpecialProduct(): Observable<IResponse<IProduct[]>> {
    return this._http_service.get('products/special-product')
}

  standardProducts(): Observable<IResponse<IProduct[]>> {
    return this._http_service.post('products/standard-products', {})
  };
}
